import { LockKeyhole, MapPinned, Sparkles } from "lucide-react";

export const AmbassadorFoundingHud = ({ foundingMembership, pendingCount, publicPath, user }) => {
  const hudCards = [
    {
      icon: Sparkles,
      label: "Founding spots remaining",
      value: `${foundingMembership?.active_count ?? 1} active • ${foundingMembership?.pending_count ?? 5} pending`,
      detail: `${foundingMembership?.available_count ?? 12} seats are still available in the current ledger.`,
      testId: "ambassador-founding-hud-scarcity-card",
    },
    {
      icon: LockKeyhole,
      label: "Private Showroom",
      value: user?.showroom_status === "public_live" ? "Public live" : "Active",
      detail: `${pendingCount} synced listings stay hidden from the public marketplace until activation.`,
      testId: "ambassador-founding-hud-lock-card",
    },
    {
      icon: MapPinned,
      label: "Boutique path",
      value: publicPath.replace(/^https?:\/\//, ""),
      detail: user?.showroom_status === "public_live" ? "Now discoverable from the live marketplace." : "Provisioned and ready for your private walkthrough.",
      testId: "ambassador-founding-hud-path-card",
    },
  ];

  return (
    <div className="rounded-[32px] border border-[#D4AF37]/18 bg-[linear-gradient(160deg,#1A1A1A_0%,#202020_58%,#27231E_100%)] p-6 text-[#F6F1E9] shadow-[0_20px_60px_rgba(22,18,11,0.2)]" data-testid="ambassador-founding-hud">
      <div className="flex flex-wrap items-end justify-between gap-4">
        <div>
          <p className="text-xs font-bold uppercase tracking-[0.24em] text-[#D4AF37]">Private Showroom HUD</p>
          <h2 className="mt-3 font-[Cormorant_Garamond,serif] text-4xl font-bold leading-none text-[#F6F1E9]">Your showroom is finished. Payment is the publish trigger.</h2>
        </div>
        <p className="rounded-full border border-[#D4AF37]/26 bg-white/5 px-4 py-2 text-xs font-bold uppercase tracking-[0.18em] text-[#D4AF37]" data-testid="ambassador-founding-hud-status-pill">
          Founding 18 allocation live
        </p>
      </div>

      <div className="mt-6 grid gap-4 lg:grid-cols-3">
        {hudCards.map((card) => {
          const Icon = card.icon;
          return (
            <div className="rounded-[26px] border border-[#D4AF37]/14 bg-[#252525] p-5" data-testid={card.testId} key={card.label}>
              <Icon className="h-5 w-5 text-[#D4AF37]" />
              <p className="mt-4 text-xs font-bold uppercase tracking-[0.2em] text-[#D4AF37]">{card.label}</p>
              <p className="mt-3 text-2xl font-semibold text-[#F6F1E9]">{card.value}</p>
              <p className="mt-3 text-sm leading-7 text-[#B8B0A5]">{card.detail}</p>
            </div>
          );
        })}
      </div>
    </div>
  );
};